<template>
  <v-flex class="client-documents">
    <v-card id="clientDocuments">
      <v-card-title class="card-title">
        Documents
        <span
          @click="showUpdateDocsModal=true"
        >UPLOAD DOCS</span>
      </v-card-title>
      <v-divider />
      <v-flex>
        <v-card-text v-if="!userDocuments.length" class="documents-container">
          <span class="no-documents__text">No documents</span>
        </v-card-text>
        <v-card-text v-else class="documents-container" :class="{ 'three-documents-container': userDocuments.length <= 3}">
          <div v-for="(doc, index) in userDocuments" :key="index" class="document-image letters">
            <v-hover>
              <div
                v-if="doc && doc.type !== 'avatar'"
                slot-scope="{hover}"
                class="document-image-placeholder"
              >
                <a v-if="checkType(doc.link)" :href="doc.link" target="_blank"><img
                  src="../../../assets/file.png"
                ></a>
                <img
                  v-else
                  :src="doc.link"
                  @click="openFullSizeImage(doc.link)"
                >
                <v-fade-transition>
                  <v-layout v-if="hover" class="image-hover white--text">
                    <v-flex>
                      <v-icon
                        :color="colors.hwayzWhite"
                        class="hover-icon"
                        title="delete"
                        @click="deleteDocument(doc)"
                      >
                        fas fa-times
                      </v-icon>
                    </v-flex>
                  </v-layout>
                </v-fade-transition>
              </div>
            </v-hover>
            <label v-if="doc.type !== 'avatar'">
              <span v-if="doc.type === 'approval_letter'"> APPROVAL LETTER</span>
              <span v-else>{{ doc.name }}</span>
            </label>
          </div>
        </v-card-text>
      </v-flex>
      <v-divider class="dividing-strip" />
    </v-card>
    <default-modal
      :show-modal="showModal"
      :width="'70%'"
      @close-modal="showModal=false"
    >
      <img :src="fullImage" class="fullImage">
    </default-modal>
    <default-modal
      :show-modal="showUpdateDocsModal"
      :modal-title="'Upload Documents'"
      :width="'450px'"
      @close-modal="showUpdateDocsModal = false"
    >
      <update-documents
        :profile="profile"
        @close-modal="showUpdateDocsModal = false"
      />
    </default-modal>
  </v-flex>
</template>
<script>
import { mapMutations } from 'vuex'
import { removeDocument } from '../../../services/profile'
import colors from '../../../scss/_colors.scss'
import DefaultModal from '../../modals/DefaultModal'
import UpdateDocuments from '../UpdateDocuments'
export default {
  components: { DefaultModal, UpdateDocuments },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors,
      userDocuments: [],
      showModal: false,
      fullImage: null,
      showUpdateDocsModal: false
    }
  },
  watch: {
    profile() {
      this.mapDocuments()
    }
  },
  created() {
    this.mapDocuments()
  },
  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    mapDocuments() {
      this.userDocuments = this.profile && this.profile.media
        ? this.profile.media.filter(item => item.type === 'approval_letter' || item.type === 'user_documents') : []
    },
    async deleteDocument(doc) {
      if (this.userDocuments) {
        const formData = new FormData()
        formData.delete('delete')
        const updatedDocuments = await removeDocument(this.profile, doc)
        this.setClientData(updatedDocuments)
      }
    },
    openFullSizeImage(doc) {
      this.fullImage = doc
      this.showModal = true
    },
    checkType(doc) {
      if (!doc) return false
      return doc.includes('.pdf') || doc.includes('.doc')
    }
  }
}
</script>

<style lang="sass">
.client-documents
  max-height: 500px
  display: flex
  flex-grow: 1
  align-items: stretch
  height: 100%
#clientDocuments
  height: 100%
  width: 100%
.documents-container
  display: flex
  flex-direction: row
  flex-wrap: nowrap
  overflow-x: auto
  height: 100%
  width: 90% !important
  // align-items: center
  margin: 4rem auto
  justify-content: space-between
.three-documents-container
  justify-content: flex-start
.letters img
  height: 100%
  width: 100%
.letters span
  color: $color-grey
  font-size: 1.3rem
  text-transform: uppercase
.letters:not(:first-child)
  margin: 0 2rem
.letters
  margin-right: 2rem
  position: relative
  width: 70px
  .document-image
    transition: 0.5s all
    cursor: pointer
    height: 100%
    width: 100%
    &-placeholder
      display: flex
      flex-flow: column
      align-items: center
      justify-content: center
      margin: 0 auto
      position: relative
      height: 100px
      width: 70px
    .image-hover
      pointer-events: none
      position: absolute
      bottom: 0
      top: 0
      left: 0
      right: 0
      margin: 0 !important
      background-color: $hwayzMediumGray
      opacity: 0.9
      color: $hwayzWhite
      .hover-icon
        pointer-events: all
        font-size: $hwayzFont1rem6
        position: absolute
        top: 0.5rem
        right: 0.5rem
        cursor: pointer
.fullImage
  width: 100%
  height: 100%
  padding: 4rem 2rem 2rem
.dividing-strip
  position: absolute
  bottom: 4.5rem
  left: 0
  width: 95%
.no-documents__text
  color: $color-grey
  margin: auto auto
</style>
